<template>
  <div class="about-container">
    <div class="about-box">
      <div class="company-profile-container">
        <div class="company-profile-img">
          <img src="../../assets/company-profile.png"
               alt="" />
        </div>
        <div class="content-container">
          <img src="../../assets/aboutus.png"
               alt="" />
          <div class="company-profile-content">
            {{ companyInfo.pc_company_profile }}
          </div>
        </div>
      </div>
      <div class="business-scope-container">
        <div class="business-scope-box">
          <div class="business-scope-img">
            <img src="../../assets/business-scope.png"
                 alt="" />
          </div>
          <div class="business-scope-content">
            <div class="business-scope-title">我司主要的业务范围有：</div>
            <div class="business-scope-context">
              {{ companyInfo.pc_business_scope }}
            </div>
          </div>
        </div>
      </div>
      <div class="contactus-container">
        <div class="map-container"
             id="mapcontainer">
          <!-- <el-amap
            vid="amapDemo"
            :zoom="zoom"
            :center="center"
            style="height: 100%"
          >
            <el-amap-marker
              v-for="marker in markers"
              :position="marker.position"
              :events="marker.events"
              :key="marker.index"
            ></el-amap-marker>
            <el-amap-info-window
              v-for="window in windows"
              :offset="window.offset"
              :position="window.position"
              :content="window.content"
              :open="window.open"
              :key="window.index"
            ></el-amap-info-window>
          </el-amap> -->
        </div>
        <div class="contact-way-container">
          <img src="../../assets/contactus.png"
               alt="联系我们"
               class="contactus-img" />
          <div class="contact-way-content">
            <div class="contact-way-item"
                 v-for="(item, index) in contactList"
                 :key="index">
              <img :src="svgList[index]"
                   alt=""
                   class="contactus-svg" />
              <span>{{ item }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="advisory-container">
        <img src="../../assets/advisory.png"
             alt="" />
        <div class="advisory-form">
          <el-form ref="messageForm"
                   :model="messageForm">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item>
                  <el-input v-model="messageForm.name"
                            placeholder="您的称呼"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="contact"
                              :rules="[
                    {
                      required: true,
                      message: '请输入邮箱/电话',
                      trigger: 'blur',
                    },
                  ]">
                  <el-input v-model="messageForm.contact"
                            placeholder="*如何联系您（邮箱/电话）"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item prop="message"
                              :rules="[
                    {
                      required: true,
                      message: '请输入留言内容',
                      trigger: 'blur',
                    },
                  ]">
                  <el-input type="textarea"
                            :autosize="{ minRows: 8, maxRows: 10 }"
                            placeholder="请输入留言内容"
                            v-model="messageForm.message">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <el-button type="info"
                   class="submit-msg-btn"
                   @click="submitMessage"
                   :loading="isLoading">提交留言</el-button>
      </div>
    </div>
    <div class="contact-box">
      <Contact />
    </div>
  </div>
</template>

<script>
import Contact from "@/components/Contact";
import { getCompanyInfo, postMessage } from "@/api/home";
const phoneSvg = require("../../assets/phone.svg");
const messageSvg = require("../../assets/email.svg");
const positionSvg = require("../../assets/position.svg");
// import AMap from 'vue-amap'
import { lazyAMapApiLoaderInstance } from "vue-amap";
var map;
export default {
  name: "about",
  components: { Contact },
  data () {
    return {
      companyInfo: {},
      contactList: [],
      svgList: [phoneSvg, messageSvg, positionSvg],
      messageForm: {
        name: "",
        contact: "",
        message: "",
      },
      isLoading: false,

      unit: "厦门不止于华文化传媒有限公司",
      address: "福建省厦门市集美区软件园三期C08栋802A",
      markers: [],
      windows: [],
      center: [118.035995, 24.621755],
      zoom: 22,
    };
  },
  created () {
    this.getCompanyInfo();
  },
  mounted () {
    if (window.AMap) {
      this.initMap();
    } else {
      setTimeout(() => {
        this.initMap();
      }, 1000);
    }
  },
  methods: {
    initMap () {
      // 创建地图实例
      map = new window.AMap.Map("mapcontainer", {
        zoom: this.zoom,
        center: this.center,
        resizeEnable: true,
      });
      const marker = new AMap.Marker({ position: this.center, map });
      marker.on("click", function () {
        infoWindow.open(map);
      });
      const infoWindow = new AMap.InfoWindow({
        position: this.center,
        offset: new AMap.Pixel(0, -30),
        content:
          "<div style='font-size:18px;margin: 10px'>" +
          this.unit +
          "</div>" +
          "<div style='font-size:16px;margin: 10px'>" +
          this.address +
          "</div>",
      });
      infoWindow.open(map);
    },
    submitMessage () {
      this.$refs.messageForm.validate((valid) => {
        if (valid) {
          this.isLoading = true;
          postMessage(this.messageForm)
            .then((res) => {
              this.isLoading = false;
              if (res.code === 10000) {
                this.$message.success("添加留言成功");
                this.$refs.messageForm.resetFields();
              }
            })
            .catch((_) => {
              this.isLoading = false;
            });
        }
      });
    },
    getCompanyInfo () {
      this.contactList = [];
      getCompanyInfo().then((res) => {
        if (res.data) {
          this.companyInfo = res.data;
          if (res.data.contact) {
            this.contactList = res.data.contact.split("\n");
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/mixin.less";
@import "~@/styles/var.less";

.about-container {
  width: 100%;
}
.company-profile-container {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  padding: 62px 63px 66px 63px;
  box-sizing: border-box;
}
.company-profile-img {
  width: 544px;
  height: 370;
  border-radius: 10px;
  overflow: hidden;
  margin-right: 51px;
}
.company-profile-img img,
.business-scope-img img {
  width: 100%;
  object-fit: cover;
}
.content-container img {
  width: 170px;
  height: 62px;
  object-fit: cover;
  margin-bottom: 35px;
}
.company-profile-content {
  font-size: 14px;
  font-weight: 400;
  color: @words;
  white-space: pre-wrap;
  width: 479px;
}
.company-profile-content.second {
  margin-top: 35px;
}
.business-scope-container {
  width: 100%;
  height: 347px;
  background: #ffffff;
}
.business-scope-box {
  width: 1200px;
  margin: 0 auto;
  display: flex;
}
.business-scope-img {
  width: 166px;
  height: 62px;
  margin-left: 63px;
  margin-top: 79px;
}
.divider-line {
  width: 1px;
  height: 203px;
  background-color: #e3e3e3;
  margin: 79px 115px 0 154px;
}
.business-scope-content {
  flex: 1;
  margin-top: 75px;
  margin-left: 154px;
  padding-left: 115px;
  // padding-top: 52px;
  padding-bottom: 10px;
  border-left: 1px solid #e3e3e3;
}
.business-scope-title {
  font-size: 18px;
  font-weight: 600;
  color: @words;
}
.business-scope-context {
  font-size: 14px;
  font-weight: 400;
  color: @words;
  line-height: 32px;
  margin-top: 21px;
}
.contactus-container {
  position: relative;
  width: 1200px;
  height: 408px;
  margin: 156px auto 0;
  box-sizing: border-box;
  background: #d8d8d8;
  border-radius: 20px;
}
.contact-way-container {
  width: 391px;
  height: 370px;
  background: #ffffff;
  border-radius: 20px;
  overflow: hidden;
  position: absolute;
  top: -61px;
  right: 44px;
}
.contactus-img {
  width: 122px;
  height: 73px;
  margin-top: 40px;
  margin-left: 34px;
  margin-bottom: 118px;
}
.contact-way-item {
  display: flex;
  margin-left: 34px;
  margin-bottom: 12px;
  align-items: center;
}
.contactus-svg {
  margin-right: 18px;
}
.contact-way-item span {
  font-size: 14px;
  font-weight: 600;
  color: @words;
}
.advisory-container {
  width: 1200px;
  margin: 117px auto 138px;
}
.advisory-container img {
  width: 187px;
  height: 62px;
  object-fit: cover;
  margin-bottom: 43px;
  margin-left: 63px;
}
.submit-msg-btn {
  width: 100%;
  margin-top: 63px;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  line-height: 28px;
}
.contact-box {
  .contact-box();
}
.map-container {
  height: 100%;
}
</style>